module.exports = __webpack_public_path__ + "static/media/jcb-logo.b9d18762.svg";